export default __webpack_public_path__ + "static/media/mid-autumn-background.16f70ff3.webp";